export const getYear = state => state.reportCarrierResults.getIn(['list', 'year'])
export const getData = state => state.reportCarrierResults.getIn(['list', 'data'])
export const getFetching = state => state.reportCarrierResults.getIn(['list', 'fetching'])
export const getError = state => state.reportCarrierResults.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCarrierResults.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCarrierResults.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCarrierResults.getIn(['details', 'error'])
